module.exports = __webpack_public_path__ + "static/media/louis.ee17ff4b.jpg";